export const hasSpecialCharachterRegExp = /[!@#$%^&*/)\\(+=._-]/;
